export default __webpack_public_path__ + "static/media/uniqlohomepage.ce48d198.png";